"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeHref = void 0;
var _xss = _interopRequireDefault(require("xss"));
const sanitizeHref = string => string ? _xss.default.safeAttrValue('a', 'href', string) : '';
exports.sanitizeHref = sanitizeHref;